import {Non} from './Non';
export class DocSecurite {

	public oui: string;

	public non: Non;

	constructor() { 
		 		this.oui = '';
		this.non = new Non();
 
	}
}
